export default "__VITE_ASSET__DPdntF1f__"